/**
 * Mama Bub PDP Enhancements
 * - Sticky mobile ATC bar (show/hide on scroll)
 * - Scroll-to-cart from sticky bar
 * - CRO copy overrides
 * - Buy button text override
 * - Price anchor injection
 * - Inline FAQ injection
 */
(function () {
  "use strict";

  /* ── Sticky ATC Bar ── */
  function initStickyATC() {
    var stickyBar = document.getElementById("mb-sticky-atc");
    var stickyBtn = document.getElementById("mb-sticky-atc-btn");
    if (!stickyBar) return;

    // Fix title — replace page <title> truncation with clean product name
    var titleEl = stickyBar.querySelector(".mb-sticky-atc__title");
    if (titleEl) titleEl.textContent = "Mama Bub Seatbelt Adjuster";

    // Fix button text
    if (stickyBtn) stickyBtn.textContent = "Protect My Baby";

    var mainATC = document.querySelector(
      '.product-form__submit, [name="add"], button[type="submit"][name="add"]',
    );
    if (!mainATC) return;

    var isVisible = false;
    var ticking = false;

    function checkScroll() {
      var mainRect = mainATC.getBoundingClientRect();
      // Trigger as soon as buy button starts scrolling out of view (bottom < 60px from top)
      var shouldShow = mainRect.bottom < 60;

      if (shouldShow !== isVisible) {
        isVisible = shouldShow;
        if (isVisible) {
          stickyBar.classList.add("mb-sticky-atc--visible");
          stickyBar.setAttribute("aria-hidden", "false");
          document.body.classList.add("mb-sticky-active");
        } else {
          stickyBar.classList.remove("mb-sticky-atc--visible");
          stickyBar.setAttribute("aria-hidden", "true");
          document.body.classList.remove("mb-sticky-active");
        }
      }
      ticking = false;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(checkScroll);
          ticking = true;
        }
      },
      { passive: true },
    );

    stickyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        if (mainATC && !mainATC.disabled) {
          mainATC.click();
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          productForm.submit();
        }
      } else if (mainATC) {
        mainATC.click();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
  }

  /* ── Buy Button Copy Override ── */
  function initBuyButtonCopy() {
    function setBtnText() {
      var btn = document.querySelector(
        '.product-form__submit, button[name="add"][type="submit"]',
      );
      if (!btn) return;
      // Only override if it still reads the default Shopify text
      var t = btn.textContent.trim();
      if (
        t === "Add to cart" ||
        t === "Add To Cart" ||
        t === "ADD TO CART" ||
        t === "Add to Cart"
      ) {
        btn.textContent = "Protect My Baby — $39.99";
      }
    }

    setBtnText();
    // Re-run after variant JS may re-render the button
    [300, 800, 2000].forEach(function (d) {
      setTimeout(setBtnText, d);
    });
  }

  /* ── Price Anchor — $0.33/day line below buy button ── */
  function initPriceAnchor() {
    function injectAnchor() {
      if (document.getElementById("mb-price-anchor")) return;
      var btn = document.querySelector(
        ".product-form__buttons, .product-form__submit",
      );
      if (!btn) return;
      var container =
        btn.closest(".product-form__buttons") || btn.parentElement;
      if (!container) return;

      var anchor = document.createElement("p");
      anchor.id = "mb-price-anchor";
      anchor.style.cssText =
        "font-size:12px;color:#7A6A6A;text-align:center;margin:8px 0 0;font-family:'Plus Jakarta Sans',sans-serif;line-height:1.4;";
      anchor.innerHTML =
        "&#36;0.33&#47;day across a full pregnancy &mdash; less than your morning coffee.";
      container.insertAdjacentElement("afterend", anchor);
    }

    injectAnchor();
    setTimeout(injectAnchor, 800);
  }

  /* ── Inline FAQ below buy button ── */
  function initInlineFAQ() {
    function injectFAQ() {
      if (document.getElementById("mb-inline-faq")) return;
      // Anchor the inline FAQ directly after the doctor card (below the CTA),
      // so order is: CTA → doctor card → FAQ accordion.
      var doc = document.querySelector(".mb5-doc-card");
      var anchor = doc ? doc.closest(".mb5-hero") || doc : null;
      if (!anchor) return;

      var faq = document.createElement("div");
      faq.id = "mb-inline-faq";
      faq.style.cssText =
        "margin:16px 0 0;border-top:1px solid #F0E8E8;padding-top:14px;font-family:'Plus Jakarta Sans',sans-serif;";

      var items = [
        {
          q: "When should I start using it?",
          a: "From around 16 weeks — when the belt starts riding up onto your bump. Works through full term and post-C-section recovery too.",
        },
        {
          q: "Will it fit my car?",
          a: "Yes. Fits standard seat track rails in 95%+ of passenger vehicles — sedans, SUVs, trucks, minivans. Installs in under 2 minutes with no tools.",
        },
        {
          q: "What's different from a cheap clip?",
          a: "Cheap clips reposition the belt. Mama Bub anchors to your car's steel seat track rail — the same structural anchor point your car uses for its own safety systems. In a crash, there's a significant difference.",
        },
      ];

      items.forEach(function (item) {
        var details = document.createElement("details");
        details.style.cssText =
          "border-bottom:1px solid #F0E8E8;padding:10px 0;";

        var summary = document.createElement("summary");
        summary.style.cssText =
          "font-size:13px;font-weight:700;color:#2D2926;cursor:pointer;list-style:none;display:flex;justify-content:space-between;align-items:center;gap:8px;";
        summary.innerHTML =
          item.q +
          '<span style="color:#E63E60;font-size:16px;flex-shrink:0;">+</span>';

        var answer = document.createElement("p");
        answer.style.cssText =
          "font-size:13px;color:#5C4A4A;line-height:1.6;margin:8px 0 4px;";
        answer.textContent = item.a;

        details.appendChild(summary);
        details.appendChild(answer);
        faq.appendChild(details);

        // Toggle + to ×
        details.addEventListener("toggle", function () {
          var icon = summary.querySelector("span");
          if (icon) icon.textContent = details.open ? "×" : "+";
        });
      });

      anchor.insertAdjacentElement("afterend", faq);
    }

    setTimeout(injectFAQ, 900);
  }

  /* ── "Why you need it" educational accordion, directly under the CTA ── */
  function initWhyAccordion() {
    function injectWhy() {
      if (document.getElementById("mb-why-acc")) return;
      var btns =
        document.querySelector(".product-form__buttons") ||
        document.querySelector(".product-form__submit") ||
        document.getElementById("mb-bundle");
      if (!btns) return;
      var anchor = btns.closest(".product-form") || btns;

      var wrap = document.createElement("details");
      wrap.id = "mb-why-acc";
      wrap.style.cssText =
        "margin:16px 0 0;border:1px solid #F0E8E8;border-radius:14px;background:#fff;overflow:hidden;font-family:'Plus Jakarta Sans',sans-serif;";

      var benefits = [
        "Directs crash force to your pelvis &amp; hip bones — not your abdomen",
        "Reduces pressure on the uterus during hard braking &amp; impacts",
        "Helps lower the risk of placental abruption, a leading cause of fetal harm in crashes",
        "Keeps the belt correctly positioned automatically — no readjusting",
        "Works across every trimester as your bump grows",
        "97% of Mama Bub users report feeling safer on every drive",
      ];
      var risks = [
        "77% of pregnant women wear their seatbelt incorrectly — over the bump, not below it",
        "A belt across the belly focuses crash force on the uterus &amp; baby",
        "Placental abruption causes 82% of fetal trauma deaths in crashes — belt position is a major factor",
        "Even a routine hard brake can tighten a mis-worn belt sharply across the abdomen",
        "Loosening or under-buckling to avoid pressure is far more dangerous — never recommended",
      ];
      function li(text, mark, color) {
        return (
          '<li style="display:flex;gap:9px;align-items:flex-start;font-size:13px;line-height:1.55;color:#5C4A4A;margin:0 0 8px;">' +
          '<span style="color:' +
          color +
          ';font-weight:800;flex-shrink:0;line-height:1.4;">' +
          mark +
          "</span><span>" +
          text +
          "</span></li>"
        );
      }
      wrap.innerHTML =
        '<summary style="list-style:none;cursor:pointer;padding:15px 18px;display:flex;justify-content:space-between;align-items:center;gap:10px;font-size:14.5px;font-weight:800;color:#2D2926;">' +
        "Why you need a pregnancy seat belt adjuster" +
        '<span class="mb-why-ico" style="color:#E63E60;font-size:20px;flex-shrink:0;line-height:1;">+</span>' +
        "</summary>" +
        '<div style="padding:2px 18px 18px;">' +
        '<p style="font-size:13px;line-height:1.65;color:#5C4A4A;margin:0 0 14px;">A standard seatbelt is crash-tested for a non-pregnant body, so the lap belt rides up over your bump instead of your hips. Mama Bub anchors it low across your hip bones — the part of your body built to absorb crash force — guiding the belt you already wear into the position doctors recommend, every drive.</p>' +
        '<div style="font-size:11px;font-weight:800;letter-spacing:.6px;text-transform:uppercase;color:#2E5C3E;margin:0 0 9px;">Safety benefits for mother &amp; baby</div>' +
        '<ul style="list-style:none;margin:0 0 16px;padding:0;">' +
        benefits
          .map(function (b) {
            return li(b, "&#10003;", "#2E5C3E");
          })
          .join("") +
        "</ul>" +
        '<div style="font-size:11px;font-weight:800;letter-spacing:.6px;text-transform:uppercase;color:#C0392B;margin:0 0 9px;">Risks of a wrongly worn belt</div>' +
        '<ul style="list-style:none;margin:0 0 14px;padding:0;">' +
        risks
          .map(function (r) {
            return li(r, "&#10007;", "#C0392B");
          })
          .join("") +
        "</ul>" +
        '<p style="font-size:13px;line-height:1.65;color:#5C4A4A;margin:0;">Mama Bub removes the guesswork — set it once and it keeps the belt low across your hips for the rest of your pregnancy.</p>' +
        "</div>";

      wrap.addEventListener("toggle", function () {
        var ico = wrap.querySelector(".mb-why-ico");
        if (ico) ico.textContent = wrap.open ? "×" : "+";
      });

      anchor.insertAdjacentElement("afterend", wrap);
    }
    setTimeout(injectWhy, 950);
    setTimeout(injectWhy, 2200);
  }

  /* ── CRO Copy Overrides ── */
  function initCopyOverrides() {
    function applyOverrides() {
      // 1. Product Title
      var titleEl = document.querySelector(
        "h1.mb-pdp-title, h1.product__title, .product__title h1",
      );
      if (titleEl) {
        var t = titleEl.textContent.trim().toLowerCase();
        if (
          (t.includes("protect your baby") || t.includes("pregnancy belt")) &&
          !t.includes("pregnant bodies")
        ) {
          titleEl.innerHTML =
            "Your Seatbelt Wasn't Made for<br>Pregnant Bodies. <em>This Was.</em>";
          titleEl.style.lineHeight = "1.15";
          titleEl.style.fontSize = "26px";
        }
      }

      // 2. Product Subtitle
      document.querySelectorAll("p").forEach(function (el) {
        var t = el.textContent.toLowerCase();
        if (
          t.includes("crash-tested") &&
          t.includes("adjuster") &&
          !t.includes("recommended by ob-gyns")
        ) {
          el.textContent =
            "The only crash-tested pregnancy seatbelt device recommended by OB-GYNs. Trusted by 50,000+ moms.";
        }
      });

      // 3. Featured Reviews Heading
      var reviewsHeading = document.querySelector(
        "#mb-featured-reviews h2, .mb-featured-reviews h2",
      );
      if (reviewsHeading) {
        var t = reviewsHeading.textContent.trim();
        if (t.includes("Real Moms") || t.includes("Real Stories")) {
          reviewsHeading.textContent = "Why Moms Don't Drive Without It";
        }
      }

      // 4. Value Stack copy
      var searchRoot =
        document.querySelector(".product__description.rte") ||
        document.querySelector("#MainContent") ||
        document.body;
      searchRoot
        .querySelectorAll("td, th, span, p, div, li")
        .forEach(function (el) {
          if (el.children.length > 2) return;
          var t = el.textContent.trim();
          if (t === "Belt Positioned Below Bump") {
            el.textContent = "Baby Protected From Belt Pressure";
          } else if (t === "Zero Digging or Red Marks") {
            el.textContent = "No More Pain or Red Marks";
          } else if (t === "REAL MOM STORY") {
            el.textContent = "TRUE STORY";
          }
        });

      // 5. Featured Reviews CTA
      var reviewsBtn = document.querySelector(".mb-featured-reviews__btn");
      if (reviewsBtn && reviewsBtn.textContent.includes("PROTECT YOUR BABY")) {
        reviewsBtn.textContent = "GET MAMA BUB — $39.99 »";
        var micro = reviewsBtn.nextElementSibling;
        if (
          micro &&
          micro.classList.contains("mb-featured-reviews__microcopy")
        ) {
          micro.textContent =
            "Tracked Shipping · 30-Day Money-Back · Installs in 2 Minutes";
        }
      }

      // 6. Fix "mums" → "moms" (British → US English consistency)
      document.querySelectorAll("p, li, div, span").forEach(function (el) {
        if (el.children.length > 0) return;
        if (
          el.textContent.includes(" mums ") ||
          el.textContent.includes(" mums.") ||
          el.textContent.includes("of mums")
        ) {
          el.textContent = el.textContent
            .replace(/ mums /g, " moms ")
            .replace(/ mums\./g, " moms.")
            .replace(/of mums/g, "of moms");
        }
      });

      // 7. Remove Alex Morgan from authority section (dilutes medical credibility)
      document
        .querySelectorAll(".v5-trust-img, img[alt*='Alex Morgan']")
        .forEach(function (el) {
          var card = el.closest("div");
          if (
            card &&
            (card.textContent.includes("Alex Morgan") ||
              card.textContent.includes("Product Engineer"))
          ) {
            card.style.display = "none";
            // Make the remaining Dr. Hoffman div full-width
            var parent = card.parentElement;
            if (parent) parent.style.gridTemplateColumns = "1fr";
          }
        });
      // Also remove by text content
      document.querySelectorAll("p, div").forEach(function (el) {
        if (
          el.children.length === 0 &&
          el.textContent.trim() === "Alex Morgan, Product Engineer"
        ) {
          el.style.display = "none";
        }
      });

      // 8. Neutralize any residual NHS references — product is not UK-only.
      // (Source copy is fixed in the templates; this is the editor-proof net.)
      document
        .querySelectorAll("p, li, span, div, strong, h2, h3, summary")
        .forEach(function (el) {
          if (el.children.length > 0) return;
          var t = el.textContent;
          if (!t || t.indexOf("NHS") === -1) return;
          el.textContent = t
            .replace(/the way the NHS recommends/g, "the way OB-GYNs recommend")
            .replace(
              /where the NHS says it should be/g,
              "where doctors say it should be",
            )
            .replace(/NHS-Aligned Design/g, "OB-GYN-Aligned Design")
            .replace(
              /NHS\s*(?:&|&amp;)\s*NHTSA Official Guidance/g,
              "NHTSA & ACOG Guidance",
            )
            .replace(/from NHTSA, NHS, and ACOG/g, "from NHTSA and ACOG")
            .replace(
              /follows NHS and NHTSA guidance/g,
              "follows NHTSA and ACOG guidance",
            )
            .replace(/\bNHS\b/g, "OB-GYNs");
        });
    }

    applyOverrides();
    if (window.MutationObserver) {
      var debounceTimer;
      new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyOverrides, 150);
      }).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    [500, 1000, 3000, 5000].forEach(function (delay) {
      setTimeout(applyOverrides, delay);
    });
  }

  /* ── Fix comparison table layout ──
     Two problems:
     1. Grid inherits RTL from store locale → force LTR.
     2. The empty first header cell collapses to width 0, shifting the
        whole header row one column left (Generic Clips lands above the
        feature labels). Give it a "Feature" label so it holds column 1. */
  function initCompareTableFix() {
    function fixTable() {
      var grid = document.querySelector(".v5-compare-grid");
      if (!grid) return;
      grid.style.setProperty("direction", "ltr", "important");
      Array.prototype.forEach.call(grid.children, function (cell) {
        cell.style.setProperty("direction", "ltr", "important");
      });
      // Fill the empty first header cell so it occupies its grid track.
      var first = grid.children[0];
      if (
        first &&
        first.classList.contains("v5-ch") &&
        !first.classList.contains("v5-ch-hero") &&
        first.textContent.trim() === ""
      ) {
        first.textContent = "Feature";
        first.style.setProperty("font-size", "11px", "important");
        first.style.setProperty("font-weight", "800", "important");
        first.style.setProperty("letter-spacing", "1px", "important");
        first.style.setProperty("text-transform", "uppercase", "important");
        first.style.setProperty("color", "#9CA3AF", "important");
        first.style.setProperty("display", "flex", "important");
        first.style.setProperty("align-items", "flex-end", "important");
      }
    }
    setTimeout(fixTable, 600);
    setTimeout(fixTable, 1500);
    setTimeout(fixTable, 3000);
  }

  /* ── Deduplicate Sarah M. story (appears twice on page) ── */
  function initDeduplicateSarahStory() {
    setTimeout(function () {
      var sarahCount = 0;
      document.querySelectorAll("*").forEach(function (el) {
        if (
          el.children.length === 0 &&
          el.textContent.includes("Sarah M.") &&
          el.textContent.includes("VERIFIED")
        ) {
          sarahCount++;
          if (sarahCount > 1) {
            var card = el.closest(
              ".v5-review-card, .real-mom-story, section, div[class*='story'], div[class*='review']",
            );
            if (card) card.style.display = "none";
          }
        }
      });
      // More reliable: find all elements with the Sarah M crash story text
      var crashStoryCount = 0;
      document.querySelectorAll("p, blockquote").forEach(function (el) {
        if (
          el.textContent.includes("car ran a red light") &&
          el.textContent.includes("lost my baby")
        ) {
          crashStoryCount++;
          if (crashStoryCount > 1) {
            var section = el.closest("section, .v5-section, [class*='story']");
            if (section) section.style.display = "none";
          }
        }
      });
    }, 1000);
  }

  /* ── Final CTA before footer ── */
  function initFinalCTA() {
    setTimeout(function () {
      if (document.getElementById("mb-final-cta")) return;

      var footer = document.querySelector(
        "footer.content-for-layout, footer#shopify-section-footer, .site-footer, footer",
      );
      if (!footer) return;

      var cta = document.createElement("div");
      cta.id = "mb-final-cta";
      cta.className = "mb-final-cta";
      cta.innerHTML =
        '<p class="mb-final-cta__headline">Still deciding?</p>' +
        '<p class="mb-final-cta__sub">50,000 moms already drive with the belt where it belongs.<br>You\'re covered by our 30-day money-back guarantee.</p>' +
        '<button class="mb-final-cta__btn" onclick="window.scrollTo({top:0,behavior:\'smooth\'})">Get Mama Bub — $39.99 &rarr;</button>' +
        '<p class="mb-final-cta__trust">Tracked shipping &middot; OB-GYN recommended &middot; Installs in 2 min</p>';

      footer.parentElement.insertBefore(cta, footer);
    }, 1200);
  }

  /* ── Custom Bundle Selector (replaces Kaching) ──
     - Select-then-add: tapping a card selects it + sets the quantity.
     - Add-to-cart is handled DIRECTLY via /cart/add.js (the store has
       competing bundle apps — Kaching/Fast Bundle — that intercept the
       native form submit, so we bypass them) and we open Dawn's cart
       drawer programmatically with fresh section HTML.
     - Updates the buy button price to the selected bundle total. */
  var mbBundleQty = 1;

  function mbGetVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    // Fallback: hardcoded single variant for this product
    return "41473861615749";
  }

  function mbParse(html, selector) {
    try {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector);
    } catch (e) {
      return null;
    }
  }

  // Refresh + open the cart drawer from a clean section fetch. Falls back to
  // the full /cart page if the drawer renders with no line items (e.g. a
  // bundle app is corrupting the line-item markup).
  function mbRefreshDrawer() {
    return fetch("/?sections=cart-drawer,cart-icon-bubble", {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var drawer = document.querySelector("cart-drawer");
        var current = document.getElementById("CartDrawer");
        if (!drawer || !current) {
          window.location.href = "/cart";
          return;
        }

        var freshCD = mbParse(sections["cart-drawer"], "#CartDrawer");
        if (freshCD) current.innerHTML = freshCD.innerHTML;

        // Clear empty-state classes
        drawer.classList.remove("is-empty");
        var inner = drawer.querySelector(".drawer__inner");
        if (inner) inner.classList.remove("is-empty");

        // Update cart count bubble
        var bubble = document.getElementById("cart-icon-bubble");
        if (bubble && sections["cart-icon-bubble"]) {
          var freshBubble = mbParse(
            sections["cart-icon-bubble"],
            ".shopify-section",
          );
          bubble.innerHTML = freshBubble
            ? freshBubble.innerHTML
            : sections["cart-icon-bubble"];
        }

        // Safety net: if no line items rendered, send them to the full cart
        var hasItems =
          current.querySelector(
            ".cart-item, .cart-items, cart-drawer-items tr, [id^='CartDrawer-Item']",
          ) !== null;
        if (!hasItems) {
          window.location.href = "/cart";
          return;
        }

        // Open the drawer
        if (typeof drawer.open === "function") {
          drawer.open();
        } else {
          drawer.classList.add("active", "animate");
          document.body.classList.add("overflow-hidden");
        }
      })
      .catch(function () {
        window.location.href = "/cart";
      });
  }

  function mbAddToCart(btn) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: mbColorItems() }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.status && data.status >= 400) {
          btn.disabled = false;
          btn.textContent = original;
          console.error("[mb-bundle] add failed", data);
          return;
        }
        return mbRefreshDrawer().then(function () {
          btn.disabled = false;
          btn.textContent = original;
        });
      })
      .catch(function (e) {
        btn.disabled = false;
        btn.textContent = original;
        console.error("[mb-bundle] add error", e);
        window.location.href = "/cart";
      });
  }

  // Bundle markup — injected via JS so it survives Shopify theme-editor
  // template regeneration (which wipes custom_liquid blocks).
  var MB_BUNDLE_HTML =
    '<div class="mb-bundle" id="mb-bundle">' +
    '<div class="mb-bundle__title">Mama Bub Pack</div>' +
    '<div class="mb-bundle__options">' +
    '<label class="mb-bundle__opt" data-qty="1" data-price="39.99" data-was="69.99"><input type="radio" name="mb-bundle" value="1"><span class="mb-bundle__radio"></span><span class="mb-bundle__info"><span class="mb-bundle__name">1 Belt</span><span class="mb-bundle__desc">For your main car</span></span><span class="mb-bundle__price"><span class="mb-bundle__now">$39.99</span><span class="mb-bundle__was">$69.99</span><span class="mb-bundle__unit">$39.99/belt</span></span></label>' +
    '<label class="mb-bundle__opt mb-bundle__opt--selected" data-qty="2" data-price="59.99" data-was="79.98"><input type="radio" name="mb-bundle" value="2" checked><span class="mb-bundle__radio"></span><span class="mb-bundle__info"><span class="mb-bundle__name">2 Belts <span class="mb-bundle__save">Save $20</span></span><span class="mb-bundle__desc">For both cars &middot; most popular</span><span class="mb-bundle__ship" style="display:block;font-size:11px;font-weight:800;color:#2E5C3E;margin-top:3px;letter-spacing:.2px;">&#128666; FREE shipping</span><span class="mb-bundle__gift" style="display:flex;align-items:center;gap:6px;margin-top:5px;"><img src="https://cdn.shopify.com/s/files/1/0593/0706/5477/files/cream-1-hero.jpg?width=60" alt="Free Stretch Mark Cream" width="24" height="24" style="width:24px;height:24px;border-radius:5px;object-fit:cover;flex-shrink:0;border:1px solid #EAD9CC;"><span style="font-size:11px;font-weight:800;color:#B5752A;letter-spacing:.2px;">FREE Stretch Mark Cream ($25 value)</span></span></span><span class="mb-bundle__price"><span class="mb-bundle__now">$59.99</span><span class="mb-bundle__was">$79.98</span><span class="mb-bundle__unit">$30/belt</span></span><span class="mb-bundle__badge">Most Popular</span></label>' +
    '<label class="mb-bundle__opt" data-qty="3" data-price="79.99" data-was="119.97"><input type="radio" name="mb-bundle" value="3"><span class="mb-bundle__radio"></span><span class="mb-bundle__info"><span class="mb-bundle__name">3 Belts <span class="mb-bundle__save">Save $40</span></span><span class="mb-bundle__desc">For every vehicle</span><span class="mb-bundle__ship" style="display:block;font-size:11px;font-weight:800;color:#2E5C3E;margin-top:3px;letter-spacing:.2px;">&#128666; FREE shipping</span><span class="mb-bundle__gift" style="display:flex;align-items:center;gap:6px;margin-top:5px;"><img src="https://cdn.shopify.com/s/files/1/0593/0706/5477/files/cream-1-hero.jpg?width=60" alt="Free Stretch Mark Cream" width="24" height="24" style="width:24px;height:24px;border-radius:5px;object-fit:cover;flex-shrink:0;border:1px solid #EAD9CC;"><span style="font-size:11px;font-weight:800;color:#B5752A;letter-spacing:.2px;">FREE Stretch Mark Cream ($25 value)</span></span></span><span class="mb-bundle__price"><span class="mb-bundle__now">$79.99</span><span class="mb-bundle__was">$119.97</span><span class="mb-bundle__unit">$26.66/belt</span></span><span class="mb-bundle__badge">Best Value</span></label>' +
    "</div>" +
    "</div>";

  // Per-belt colour state, remembered across pack changes (belt # -> colour).
  var mbColors = {};

  // Render one Black/Pink dropdown per belt INSIDE the selected pack card.
  function mbRenderColorRows(qty, opt) {
    if (!opt) opt = document.querySelector(".mb-bundle__opt--selected");
    // clear any existing colour block from all cards
    document.querySelectorAll("#mb-bundle .mb-color").forEach(function (el) {
      el.parentNode.removeChild(el);
    });
    if (!opt) return;
    qty = qty || 1;
    var block = document.createElement("div");
    block.className = "mb-color";
    var html =
      '<div class="mb-color__label">Color</div><div class="mb-color__rows">';
    for (var i = 1; i <= qty; i++) {
      var val = mbColors[i] || "Black";
      var num = qty > 1 ? '<span class="mb-color__num">#' + i + "</span>" : "";
      html +=
        '<div class="mb-color__row">' +
        num +
        '<select class="mb-color__select" data-belt="' +
        i +
        '" aria-label="Belt ' +
        i +
        ' colour">' +
        '<option value="Black"' +
        (val === "Black" ? " selected" : "") +
        ">Black</option>" +
        '<option value="Pink"' +
        (val === "Pink" ? " selected" : "") +
        ">Pink</option>" +
        "</select></div>";
    }
    html += "</div>";
    block.innerHTML = html;
    // Keep clicks inside the colour block from toggling the radio card / re-selecting.
    block.addEventListener("click", function (e) {
      e.stopPropagation();
    });
    block.querySelectorAll(".mb-color__select").forEach(function (s) {
      mbColors[s.getAttribute("data-belt")] = s.value;
      s.addEventListener("change", function () {
        mbColors[s.getAttribute("data-belt")] = s.value;
      });
    });
    opt.appendChild(block);
    // Keep the free-gift line as the bottom banner (colour picker sits above it).
    var mbGift = opt.querySelector(".mb-bundle__gift");
    if (mbGift) opt.appendChild(mbGift);
  }

  // Real product variants for each colour (added in the backend).
  var MB_VARIANTS = { Black: 41473861615749, Pink: 41752491491461 };

  // Colour choices → grouped /cart/add items (one line per colour variant).
  // 2 belts Black+Pink → [{Black,1},{Pink,1}]; 3 belts all Black → [{Black,3}].
  function mbColorItems() {
    var counts = {};
    for (var i = 1; i <= mbBundleQty; i++) {
      var c = mbColors[i] === "Pink" ? "Pink" : "Black";
      counts[c] = (counts[c] || 0) + 1;
    }
    var items = [];
    Object.keys(counts).forEach(function (color) {
      items.push({
        id: MB_VARIANTS[color] || MB_VARIANTS.Black,
        quantity: counts[color],
      });
    });
    return items;
  }

  function mbInjectBundle() {
    var existing = document.getElementById("mb-bundle");
    if (existing && existing.dataset.mbjs === "1") return; // ours, done
    var wrap = document.createElement("div");
    wrap.innerHTML = MB_BUNDLE_HTML;
    var node = wrap.firstChild;
    node.dataset.mbjs = "1";
    if (existing) {
      // A template-rendered bundle exists (custom_liquid_bundle block) —
      // replace it so the JS markup (1-belt default + per-belt unit pricing)
      // is authoritative and survives theme-editor regeneration.
      existing.parentNode.replaceChild(node, existing);
      return;
    }
    // Insert directly above the buy-button area in the product form
    var anchor =
      document.querySelector(".product-form__buttons") ||
      document.querySelector(".product-form__submit");
    if (!anchor) return;
    var container = anchor.closest(".product-form") || anchor.parentElement;
    if (!container) return;
    container.parentElement.insertBefore(node, container);
  }

  function initBundleSelector() {
    mbInjectBundle();
    var bundle = document.getElementById("mb-bundle");
    if (!bundle || bundle.dataset.mbInit) return;
    bundle.dataset.mbInit = "1";

    var opts = bundle.querySelectorAll(".mb-bundle__opt");
    if (!opts.length) return;

    function buyButtons() {
      return document.querySelectorAll(
        ".product-form__submit, #mb-sticky-atc-btn",
      );
    }

    function select(opt) {
      opts.forEach(function (o) {
        o.classList.remove("mb-bundle__opt--selected");
        var r = o.querySelector("input");
        if (r) r.checked = false;
      });
      opt.classList.add("mb-bundle__opt--selected");
      var radio = opt.querySelector("input");
      if (radio) radio.checked = true;

      mbBundleQty = parseInt(opt.getAttribute("data-qty") || "1", 10);
      mbRenderColorRows(mbBundleQty, opt);
      var price = opt.getAttribute("data-price") || "39.99";
      var was = opt.getAttribute("data-was") || "69.99";

      // Keep the sticky bar price in sync with the selected bundle
      var skCur = document.querySelector(".mb-sticky-atc__price-current");
      var skCmp = document.querySelector(".mb-sticky-atc__price-compare");
      if (skCur) skCur.textContent = "$" + price;
      if (skCmp) skCmp.textContent = "$" + was;

      // Running savings callout (compare-at total − bundle price)
      var saveEl = document.getElementById("mb-bundle-savings");
      if (saveEl) {
        var saveAmt = (parseFloat(was) - parseFloat(price)).toFixed(2);
        saveEl.innerHTML =
          "&#127881; You&rsquo;re saving $" + saveAmt + " today";
      }

      buyButtons().forEach(function (btn) {
        if (btn.id === "mb-sticky-atc-btn") {
          btn.textContent = "Protect My Baby";
        } else {
          btn.textContent = "Protect My Baby — $" + price;
        }
      });
    }

    opts.forEach(function (opt) {
      opt.addEventListener("click", function () {
        select(opt);
      });
    });

    // Intercept the buy buttons → direct add-to-cart (capture phase so we
    // run before the competing bundle apps' listeners).
    buyButtons().forEach(function (btn) {
      if (btn.dataset.mbBound) return;
      btn.dataset.mbBound = "1";
      btn.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          mbAddToCart(btn);
        },
        true,
      );
    });

    // Default to pre-selected option (or "Most Popular" 2nd card)
    var preselected =
      bundle.querySelector(".mb-bundle__opt--selected") || opts[0];
    select(preselected);
  }

  /* ── Custom Mobile Gallery (full overhaul) ──
     Dawn's mobile slider forces the <img> to 2× height (crops square
     images to the upper body) and its thumbnails fight our CSS. We bypass
     it entirely: hide Dawn's media wrapper on mobile and build a clean
     scroll-snap carousel with working dot pagination + image counter. */
  // Request a right-sized image: display width × capped DPR. Big enough to
  // stay crisp on retina, small enough to load fast (a flat 1500 was heavy).
  function mbReqWidth() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var w = Math.round((window.innerWidth || 390) * dpr);
    // round up to nearest 100, clamp to a sensible range
    w = Math.ceil(w / 100) * 100;
    return Math.max(800, Math.min(w, 1200));
  }

  function mbSrcAt(src, width) {
    if (!src) return src;
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set("width", String(width));
      u.searchParams.delete("height");
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function mbBuildGallery() {
    var wrapper = document.querySelector(".product__media-wrapper");
    if (!wrapper) return;
    if (document.getElementById("mbg")) return; // already built

    // Collect unique image sources from Dawn's media items
    var reqW = mbReqWidth();
    var imgs = wrapper.querySelectorAll(".product__media-item img");
    var seen = {};
    var sources = [];
    Array.prototype.forEach.call(imgs, function (img) {
      // src may have been moved to data-src by the inline parse-time strip
      // (which stops Dawn downloading duplicate images on mobile).
      var src =
        img.getAttribute("data-src") ||
        img.currentSrc ||
        img.src ||
        (img.getAttribute("data-srcset") || "").split(" ")[0];
      if (!src) return;
      var key = src.split("?")[0];
      if (seen[key]) return;
      seen[key] = 1;
      sources.push({ base: src, alt: img.alt || "Mama Bub" });
    });
    if (sources.length < 1) return;

    // Build carousel — only the first image loads eagerly (high priority);
    // the rest lazy-load + decode async so the page paints fast.
    var gal = document.createElement("div");
    gal.id = "mbg";
    gal.className = "mbg";
    // Only the FIRST slide gets a real src (loads immediately). The rest hold
    // their URL in data-src and are loaded by IntersectionObserver as the user
    // swipes — native lazy doesn't defer horizontally-offscreen carousel images.
    var slides = sources
      .map(function (s, i) {
        var first = i === 0;
        var url = mbSrcAt(s.base, reqW);
        return (
          '<div class="mbg__slide" data-i="' +
          i +
          '"><img ' +
          (first ? 'src="' + url + '"' : 'data-src="' + url + '"') +
          ' alt="' +
          (s.alt || "").replace(/"/g, "&quot;") +
          '" width="' +
          reqW +
          '" height="' +
          reqW +
          '" decoding="' +
          (first ? "auto" : "async") +
          '" fetchpriority="' +
          (first ? "high" : "low") +
          '"></div>'
        );
      })
      .join("");
    var dots = sources
      .map(function (s, i) {
        return (
          '<button type="button" class="mbg__dot' +
          (i === 0 ? " active" : "") +
          '" data-i="' +
          i +
          '" aria-label="Image ' +
          (i + 1) +
          '"></button>'
        );
      })
      .join("");
    gal.innerHTML =
      '<div class="mbg__track" id="mbg-track">' +
      slides +
      "</div>" +
      '<button type="button" class="mbg__arrow mbg__arrow--prev" aria-label="Previous image"></button>' +
      '<button type="button" class="mbg__arrow mbg__arrow--next" aria-label="Next image"></button>' +
      '<div class="mbg__counter"><span id="mbg-cur">1</span> / ' +
      sources.length +
      "</div>" +
      '<div class="mbg__dots">' +
      dots +
      "</div>";

    // Hide Dawn's gallery but KEEP the wrapper (inherit its grid column +
    // order on desktop) and place ours inside it.
    Array.prototype.forEach.call(wrapper.children, function (c) {
      c.style.setProperty("display", "none", "important");
    });
    wrapper.appendChild(gal);

    // Stop Dawn's now-hidden gallery from downloading its own copies of every
    // image (display:none does NOT cancel <img> loads — that double payload
    // was the slowness). Strip srcs so only OUR gallery's images load.
    wrapper
      .querySelectorAll(".product__media-item img, .product__media-item source")
      .forEach(function (el) {
        el.removeAttribute("srcset");
        el.removeAttribute("data-srcset");
        if (el.tagName === "IMG") {
          el.setAttribute("loading", "lazy");
          el.removeAttribute("src");
        }
      });

    var track = gal.querySelector("#mbg-track");
    var dotEls = gal.querySelectorAll(".mbg__dot");
    var curEl = gal.querySelector("#mbg-cur");
    var prevBtn = gal.querySelector(".mbg__arrow--prev");
    var nextBtn = gal.querySelector(".mbg__arrow--next");

    // Lazy-load slides 2..N — slide 2 eagerly, the rest via a wide-margin IO
    // plus a full background prefetch on idle (so swiping never waits).
    function loadSlide(slideEl) {
      var img = slideEl.querySelector("img[data-src]");
      if (img) {
        img.src = img.getAttribute("data-src");
        img.removeAttribute("data-src");
      }
    }
    var allSlides = gal.querySelectorAll(".mbg__slide");
    function loadAllSlides() {
      Array.prototype.forEach.call(allSlides, loadSlide);
    }
    if (allSlides[1]) loadSlide(allSlides[1]); // likely first swipe target
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              loadSlide(e.target);
              io.unobserve(e.target);
            }
          });
        },
        { root: track, rootMargin: "600px" },
      );
      Array.prototype.forEach.call(allSlides, function (s, i) {
        if (i > 1) io.observe(s);
      });
      var idle =
        window.requestIdleCallback ||
        function (fn) {
          setTimeout(fn, 1500);
        };
      if (document.readyState === "complete") {
        idle(loadAllSlides);
      } else {
        window.addEventListener("load", function () {
          idle(loadAllSlides);
        });
      }
    } else {
      // No IO support → load all (rare)
      loadAllSlides();
    }

    function setActive(i) {
      dotEls.forEach(function (d, di) {
        d.classList.toggle("active", di === i);
      });
      if (curEl) curEl.textContent = i + 1;
      if (prevBtn) prevBtn.classList.toggle("mbg__arrow--hidden", i <= 0);
      if (nextBtn)
        nextBtn.classList.toggle("mbg__arrow--hidden", i >= sources.length - 1);
    }

    var ticking = false;
    track.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          setActive(i);
          ticking = false;
        });
      },
      { passive: true },
    );

    dotEls.forEach(function (d) {
      d.addEventListener("click", function () {
        var i = parseInt(d.getAttribute("data-i"), 10);
        track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
        setActive(i);
      });
    });

    function go(delta) {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      var n = Math.max(0, Math.min(sources.length - 1, i + delta));
      track.scrollTo({ left: n * track.clientWidth, behavior: "smooth" });
      setActive(n);
    }
    if (prevBtn)
      prevBtn.addEventListener("click", function () {
        go(-1);
      });
    if (nextBtn)
      nextBtn.addEventListener("click", function () {
        go(1);
      });
    setActive(0);
  }

  /* ── Risk-reversal trust strip directly under the buy button ── */
  function initTrustStrip() {
    function inject() {
      if (document.getElementById("mb-trust-strip")) return;
      var anchor = document.getElementById("mb-price-anchor");
      var ref, mode;
      if (anchor) {
        ref = anchor;
        mode = "beforebegin";
      } else {
        var btns = document.querySelector(".product-form__buttons");
        if (!btns) return;
        ref = btns;
        mode = "afterend";
      }
      var strip = document.createElement("div");
      strip.id = "mb-trust-strip";
      strip.className = "mb-trust-strip";
      strip.innerHTML =
        '<span class="mb-trust-strip__item">🔒 30-Day Money-Back</span>' +
        '<span class="mb-trust-strip__item">🚚 Tracked Worldwide</span>' +
        '<span class="mb-trust-strip__item">⚡ Installs in 2 Min</span>';
      ref.insertAdjacentElement(mode, strip);
    }
    inject();
    [600, 1200, 2500].forEach(function (d) {
      setTimeout(inject, d);
    });
  }

  /* ── Make the ★ rating tappable → scroll to reviews ── */
  function initRatingScroll() {
    function bind() {
      var rating = Array.prototype.find.call(
        document.querySelectorAll("span, div, a, p"),
        function (n) {
          return (
            n.children.length <= 2 &&
            (n.textContent || "").length < 60 &&
            /Rated\s*4\.9|4\.9\s*\/\s*5/i.test(n.textContent || "")
          );
        },
      );
      if (!rating || rating.dataset.mbRatingBound) return;
      rating.dataset.mbRatingBound = "1";
      rating.style.cursor = "pointer";
      rating.setAttribute("title", "Read verified reviews");
      rating.addEventListener("click", function () {
        var target = document.querySelector(
          "#looxReviews, .loox-reviews-default, [data-loox-aggregate], .mb-featured-reviews",
        );
        if (!target) {
          target = Array.prototype.find.call(
            document.querySelectorAll("h2, h3"),
            function (h) {
              return /reviews|don.t drive without it|real moms/i.test(
                h.textContent || "",
              );
            },
          );
        }
        if (target)
          target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    bind();
    [1000, 2500].forEach(function (d) {
      setTimeout(bind, d);
    });
  }

  /* ── Init on DOM ready ── */
  function initAll() {
    initStickyATC();
    initCopyOverrides();
    initBuyButtonCopy();
    initInlineFAQ();
    initWhyAccordion();
    initTrustStrip();
    initRatingScroll();
    initCompareTableFix();
    initDeduplicateSarahStory();
    initFinalCTA();
    initBundleSelector();
    mbBuildGallery();
    [600, 1500, 3000].forEach(function (d) {
      setTimeout(initBundleSelector, d);
      setTimeout(mbBuildGallery, d);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
